import React, { Component, Fragment } from 'react';

import MakeItYours from 'components/MakeItYours';
import HowItWorks from 'components/HowItWorks';
import PricingPlans from 'components/PricingPlans';
import BrandSlider from 'components/BrandSlider';
import Testimonials from 'components/Testimonials';
import { HeaderUnLoggedIn } from 'scenes/Header';
import heroImg from 'images/hero-img.png';
import heroWaves from 'images/hero-waves.png';
import Footer from 'scenes/Footer';
import SalescampHelper from 'helpers/SalescampHelper';
import getUrlParam from 'helpers/getUrlParam';

import ReactPixel from 'react-facebook-pixel';

class Landing extends Component {
  static propTypes = {};

  componentDidMount() {
    SalescampHelper.saveTokenFromUrl();
    ReactPixel.pageView();
    this.parseTrialToken();
  }

  parseTrialToken = () => {
    const trialToken = getUrlParam('trial_token');
    localStorage.setItem('trialToken', trialToken);
    if (trialToken !== null && trialToken !== ''){
      this.props.history.push(`/sign_up`)
    }
  };

  render() {
    return (
      <Fragment>
        <HeaderUnLoggedIn />
        <div className="hero">
          <div className="hero__content">
            <div className="hero__descr">
              <h1 className="hero__title">
                You only have one link. <br />
                Make it count
              </h1>
              <h2 className="hero__subtitle" />
              <p className="hero__text">
                Gone are the days when all your content was in one location.
                <br /> So why be satisfied with only one link in your social
                media bio?
              </p>
              <a href="#pricing_plans" className="btn btn-blue">
                Get started
              </a>
            </div>
            <div className="hero__img">
              <img src={heroImg} alt="" />
            </div>
          </div>
          <div className="hero-waves">
            <img src={heroWaves} alt="" />
          </div>
        </div>
        <MakeItYours />
        <HowItWorks />
        <BrandSlider />
        <PricingPlans />
        <Testimonials />
        <Footer />
      </Fragment>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/landing/Landing.js